module.exports = __webpack_public_path__ + "img/file-earmark-lock-fill.aa4a3b8f.svg";